<template>
  <!-- <header v-bind:class="headerColor"> -->
  <header>
    <div id="left">
      <router-link v-if="isAdmin" tag="button" class="button" to="admin">
        <span class="icon"><Icon :icon="mdiLock"></Icon></span>
        <span>To Dashboard</span>
      </router-link>
      <modal-button
        label="Browse Image"
        :icon="mdiTable"
        :modal-setting="{
          hasModalCard: true,
          trapFocus: true
        }"
      >
        <floorplan-browser />
      </modal-button>
    </div>
    <div id="middle">
      <div class="floorplan">
        <span>{{ floorplanName }}</span>
      </div>
    </div>
    <div id="right">
      <b-button type="is-light" v-on="{ click: onClick(true) }">
        <span class="icon"><Icon :icon="mdiChevronRight"></Icon></span>
      </b-button>
      <b-button type="is-light" v-on="{ click: onClick(false) }">
        <span class="icon"><Icon :icon="mdiChevronLeft"></Icon></span>
      </b-button>
      <modal-button
        label="Tag"
        :modal-setting="{
          hasModalCard: true,
          trapFocus: true
        }"
        ><tags-modal />
      </modal-button>
      <annotation-state-button />
      <save-button />
    </div>
  </header>
</template>

<script>
import { SnackbarProgrammatic as Snackbar } from "buefy";
import { computed } from "@vue/composition-api";
import useWarnings from "@/composables/useWarnings";
import SaveButton from "@/components/SaveButton";
import AnnotationStateButton from "@/components/AnnotationStateButton";
import ModalButton from "@/components/ModalButton";
import FloorplanBrowser from "@/components/FloorplanBrowser";
import TagsModal from "@/components/TagsModal";
import ui from "@/store/modules/ui";
import annotations from "@/store/modules/annotations";
import { mdiChevronRight, mdiChevronLeft, mdiTable, mdiLock } from "@mdi/js";
import Icon from "../components/Icon";

export default {
  components: {
    SaveButton,
    AnnotationStateButton,
    ModalButton,
    FloorplanBrowser,
    TagsModal,
    Icon
  },
  name: "AnnotatorHeader",
  setup() {
    const floorplanName = computed(() => annotations.name);
    const editorState = computed(() => annotations.getState);
    /**
     * used to switch-off certain uis for non-admins
     */
    const isAdmin = computed(() => ui.isAdmin);
    /**
     * change header color based on editting state
     */
    const headerColor = computed(() => {
      switch (editorState.value) {
        case "finished":
          return {
            "has-background-success": true
          };
        default:
          return {};
      }
    });

    /**
     * move to next/previous floorplan
     */
    const { shouldProceed } = useWarnings();
    const onClick = state => async () => {
      if (!shouldProceed()) {
        return;
      }

      ui.setIsLoadingAnnotation(true);
      try {
        await ui.cycleFloorplan(state);
        ui.setHasUnsavedChange(false);
      } catch (error) {
        console.error(
          "cycleFloorplan failed at AnnotatorHeader: ",
          error.message
        );
        Snackbar.open({
          message: error.message,
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
      } finally {
        ui.setIsLoadingAnnotation(false);
      }
    };

    return {
      isAdmin,
      headerColor,
      onClick,
      floorplanName,
      mdiChevronRight,
      mdiChevronLeft,
      mdiTable,
      mdiLock
    };
  }
};
</script>

<style lang="scss" scoped>
header {
  height: 100%;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  // border-bottom: solid 3px hsl(0, 0%, 90%);
  box-shadow: 0 0 10px $border-grey;
}

#left {
  display: flex;
  flex: 0 1 0;
  flex-direction: row;

  & > * {
    margin-right: 0.5rem;
  }
}

#middle {
  flex: 1 0 0;
}

#right {
  display: flex;
  flex: 0 1 0;
  flex-direction: row-reverse;

  & > * {
    margin-left: 0.5rem;
  }
}

.floorplan {
  margin-left: 1em;
  padding-top: calc(0.4em - 1px);
  padding-bottom: calc(0.4em - 1px);
  height: 2.5em;
  vertical-align: middle;
  text-align: center;
  & > span {
    font-size: 1.2rem;
    line-height: 1.5;
  }
}
</style>
